<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Exam Report</h5>
        </div>
        <!-- <div class="col-6 col-sm-4 text-right">
          <add-exam-setup @created="handleCreated"/>
        </div> -->
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-12">
        <!-- Filters -->
        <div class="row">
           <!-- Report Type -->
            <div class="col-md-2 col-12 mb-2">
              <a-select
                size="large"
                v-model="reportType"
                placeholder="Select Report Type"
                optionFilterProp="children"
                style="width: 100%"
                :filterOption="false"
              >
                <a-select-option value="overall">Overall - Exam wise</a-select-option>
              </a-select>
              </div>

          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
              <template v-for="schoolSession in schoolSessions">
                <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{ schoolSession.name }}
                  <small class="text-primary ml-2">
                    {{ currentSession.id === schoolSession.id ? 'Current' : '' }}
                  </small>
                </a-select-option>
              </template>
            </a-select>
          </div>

          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="All Classes"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
              >
                <a-select-option :value="undefined">All Classes</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                    {{ schoolClass.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Section Select -->
        <div class="col-md-2 col-12 mb-2">
                <a-select
                size="large"
                v-model="selectedSection"
                placeholder="All Sections"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionSelect"
                :filterOption="false"
                :disabled="!selectedClass"
            >
            <a-select-option :value="undefined">All Sections</a-select-option>
            <template v-for="section in sections">
            <a-select-option :value="section.id" :key="section.id">
            {{ section.name }}
            </a-select-option>
            </template>
            </a-select>
          </div>

          <!-- Exam Select -->
        <div class="col-md-2 col-12 mb-2">
          <a-select
          size="large"
          v-model="selectedExam"
          placeholder="Select Exam"
          style="width: 100%"
          :disabled="!schoolExams.length"
          @change="getFilteredExamReports"
        >
        <a-select-option :value="undefined">All Exams</a-select-option>
        <template v-for="exam in schoolExams">
        <a-select-option :value="exam.id" :key="exam.id">
          {{ exam.name }}
        </a-select-option>
        </template>
        </a-select>
        </div>

        <!-- Status Select -->
        <div class="col-md-2 col-12 mb-2">
          <a-select
          size="large"
          v-model="selectedStatus"
          placeholder="Status"
          style="width: 100%"
        >
          <a-select-option value="All">All</a-select-option>
          <a-select-option value="Pass">Pass</a-select-option>
          <a-select-option value="Fail">Fail</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="row">
            <div class="col-md-12 text-md-right">
              <a-form-item>
                <a-button
                  key="submit"
                  type="primary"
                  :loading="loadingExport"
                  @click="handleExport"
                  >Export</a-button
                >
              </a-form-item>
            </div>
          </div>

        <!-- Report List -->
        <!-- <div class="row justify-content-center">
           <div class="col-xl-12">
            <div class="card">
              <div class="card-body">
                <display-class-exam-report
                v-for="exam in examReportData"
                :key="exam.id"
                :examData="exam"
                />
                <a-empty
                v-if="!examReportData.length && !loading"
                description="No exam reports found"
              />
            </div>
          </div>
         </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
// import DisplayClassExamReport from '@/components/exam/examreport/Table/index'

export default {
  components: {
    // DisplayClassExamReport,
  },
  data() {
    return {
      loadingExport: false,
      loading: false,
      selectedSession: undefined,
      selectedClass: undefined,
      selectedSection: undefined,
      selectedExam: undefined,
      reportType: 'overall', // default selected report type
      selectedStatus: '', // already shown in template
      sectionSpinning: false,
      sections: [],
      schoolExams: [],
      examReportData: [],
      schoolSessions: [],
      schoolClasses: [],
      classSpinning: false,
    }
  },
  computed: {
    currentSession() {
      return find(this.schoolSessions, ['is_current', 1]) || {}
    },
  },
  watch: {
    selectedSession() {
      this.getClasses()
      this.getFilteredExamReports()
    },
    selectedClass() {
      this.getFilteredExamReports()
    },
  },
  mounted() {
    this.$http
      .get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        const current = find(this.schoolSessions, ['is_current', 1])
        this.selectedSession = current ? current.id : undefined
        this.getClasses()
        this.getExams()
        this.getFilteredExamReports()
      })
      .catch(error => {
        console.error(error)
      })
  },
  methods: {

    handleExport() {
      if (!this.selectedExam) {
        this.$message.warning('Please select an exam to export')
        return
      }

      this.loadingExport = true

      this.$http
        .get('/api/reports/student/class-exam-results/export', {
          params: {
            session_id: this.selectedSession,
            class_id: this.selectedClass,
            section_id: this.selectedSection,
            report_type: this.reportType,
            exam_id: this.selectedExam,
            status: this.selectedStatus,
          },
          responseType: 'arraybuffer',
        }).then(() => {
          this.$notification.success({
            message: 'Export Started',
            description: 'Please check Downloads page',
            duration: 0,
          })
        }).catch((err) => {
          this.$message.error('Export failed')
          console.error(err)
        }).finally(() => {
          this.loadingExport = false
        })
    },

    handleCreated() {
      this.getFilteredExamReports()
    },
    handleSessionChange(value) {
      this.selectedClass = undefined
      this.selectedExam = undefined
      this.selectedSession = value || (this.currentSession ? this.currentSession.id : undefined)
    },
    handleClassSelect(value) {
      this.selectedClass = value
      this.selectedSection = undefined
      this.selectedExam = undefined
      if (value) {
        this.sectionSpinning = true
        this.getSections(value)
      }
      this.getFilteredExamReports()
    },

    getClasses() {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: { session_id: this.selectedSession },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(console.error)
        .finally(() => {
          this.classSpinning = false
        })
    },
    getSections(classId) {
      this.$http.get(`/api/section/class/${classId}`)
        .then(({ data }) => {
          this.sections = data.data
        })
        .catch(console.error)
        .finally(() => {
          this.sectionSpinning = false
        })
    },
    getExams() {
      this.$http.get('/api/exam')
        .then(({ data }) => {
          this.schoolExams = data.data
        })
        .catch(error => {
          console.log('Error fetching exams:', error)
        })
    },
    handleSectionSelect(value) {
      this.selectedSection = value
      this.getFilteredExamReports()
    },
    async getFilteredExamReports() {
      this.loading = true
      try {
        const { data } = await this.$http.get('/api/classsectionexam', {
          params: {
            session_id: this.selectedSession,
            class_id: this.selectedClass,
            section_id: this.selectedSection,
            exam_id: this.selectedExam,
            declared: 1,
          },
        })

        const exams = data.data || []

        const fullExamPromises = exams.map(exam =>
          this.$http
            .get(`/api/classsectionexam/${exam.id}`, {
              params: {
                with_students: 1,
              },
            })
            .then(({ data }) => data.data)
            .catch(() => null)
        )

        const fullExamData = await Promise.all(fullExamPromises)

        // Keep only exams with students
        this.examReportData = fullExamData.filter(
          exam => exam && Array.isArray(exam.students) && exam.students.length > 0
        )
      } catch (error) {
        console.error(error)
        this.examReportData = []
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
/* optional styling */
</style>
